module.exports = __webpack_public_path__ + "img/Group 27921@2x.5d11595a.png";